<template>
  <ModalBase class="modal_box">
    <template v-slot:main>
      <div class="modal-warning">
        <div class="modal-warning__wrapper">
          <div class="modal-warning__title">{{ $t('warning.title') }}</div>
          <div class="modal-warning__desc">{{ guiWarningGet.message }}</div>
          <div class="modal-warning__action">
            <Button @click="close" full>{{ $t('common.close') }}</Button>
          </div>
        </div>
      </div>
    </template>
  </ModalBase>
</template>

<script>
import ModalBase from '@/components/modals/ModalBase'
import {mapActions, mapGetters} from 'vuex'
import * as types from '@/store/types'

export default {
  name: 'ModalWarning',
  components: {
    ModalBase
  },
  computed: {
    ...mapGetters({
      guiWarningGet: types.GUI.warning.get
    })
  },
  methods: {
    ...mapActions({
      guiWarningSet: types.GUI.warning.set
    }),
    close() {
      this.guiWarningSet({
        show: false,
        message: null
      })
    }
  }
}
</script>
